export const CONTACT_ATTRIBUTES = "CONTACT_ATTRIBUTES";

export const setContactAttributes = (attributes) => {
	return {
		type: CONTACT_ATTRIBUTES,
		attributes,
	};
};
